export type YesNo = 'yes' | 'no';

export type MaritalStatus = 'married' | 'not_married';

export type DisabilityCategory = 'none' | 'general' | 'special';

export type NonResidentReason = 'study_abroad' | 'disability' | 'remittance_380k';

export type SpouseIneligibilityReason =
  | 'no_shared_livelihood'
  | 'employee_income_over_limit'
  | 'spouse_family_worker'
  | 'spouse_income_over_limit';

export type SpouseSectionOutcome = 'not_applicable' | 'ineligible' | 'eligible';

export type SpouseSectionStep =
  | 'notMarriedDone'
  | 'addSpouseName'
  | 'addSpouseKana'
  | 'addSpouseDob'
  | 'sharedLivelihood'
  | 'employeeEstimatedIncome'
  | 'spouseFamilyWorker'
  | 'spouseEstimatedIncome'
  | 'ineligibleNotice'
  | 'confirmFullName'
  | 'confirmFullNameKana'
  | 'confirmMyNumber'
  | 'confirmDob'
  | 'sameHousehold'
  | 'addressIfNot'
  | 'nonResident'
  | 'nonResidentReason'
  | 'disabilityStatus'
  | 'changeDuringYear'
  | 'changeDate'
  | 'changeReason'
  | 'changeReasonOther';

export type { SpouseChangeReasonCode } from './spouseChangeReason';

export type SpouseSnapshot = {
  empFamilyId: number | null;
  fullName: string;
  fullNameKana: string;
  myNumber: string;
  dateOfBirth: string;
  livingInSameHousehold: YesNo | '';
  ifNotAddress: string;
  nonResidentFlag: YesNo | '';
  nonResidentReason: NonResidentReason | '';
  disabilityCategory: DisabilityCategory | '';
  estimatedIncome: string;
  changeDuringYear: YesNo | '';
  changeDate: string;
  /** Stored in tax_dependent.change_reason — preset code or free text for Other. */
  changeReason: string;
};

export type SpouseDeclarationSnapshot = {
  employeeEstimatedIncome: string;
  sharedLivelihood: YesNo | '';
  spouseFamilyWorker: YesNo | '';
  withholdingEligible: boolean;
  ineligibilityReason: SpouseIneligibilityReason | '';
  sectionOutcome: SpouseSectionOutcome | '';
  /** True when spouse name/kana/DOB were collected in Section 2 (not pre-existing from Family Info). */
  spouseAddedInSection: boolean;
};

export const SPOUSE_SECTION_STEP_ORDER: SpouseSectionStep[] = [
  'notMarriedDone',
  'addSpouseName',
  'addSpouseKana',
  'addSpouseDob',
  'sharedLivelihood',
  'employeeEstimatedIncome',
  'spouseFamilyWorker',
  'spouseEstimatedIncome',
  'ineligibleNotice',
  'confirmFullName',
  'confirmFullNameKana',
  'confirmMyNumber',
  'confirmDob',
  'sameHousehold',
  'addressIfNot',
  'nonResident',
  'nonResidentReason',
  'disabilityStatus',
  'changeDuringYear',
  'changeDate',
  'changeReason',
  'changeReasonOther',
];
